import { combineReducers } from 'redux';
import view from './view';
import filters from './filters';

const surveyReducer = combineReducers({
    view,
    filters
});

export default surveyReducer;